<template>
  <auth-layout :kicker="t.kicker" :title="t.title" :text="t.text">
    <h2 class="auth-card-title">{{ t.cardTitle }}</h2>

    <v-btn-toggle v-model="type" mandatory color="success" class="auth-type">
      <v-btn v-for="(option, key) in types" :key="key" :value="key" :disabled="isLoading">
        <v-icon left small>{{ option.icon }}</v-icon>
        {{ option.label }}
      </v-btn>
    </v-btn-toggle>

    <v-form ref="form" @submit.prevent="login">
      <v-text-field
        v-model="email"
        :label="t.fields.email"
        :rules="[v => !!(v && v.trim()) || t.required.email]"
        :disabled="isLoading"
        type="email"
        autocomplete="username"
        prepend-inner-icon="mdi-email-outline"
        outlined
      ></v-text-field>

      <v-text-field
        v-model="password"
        :label="t.fields.password"
        :rules="[v => !!v || t.required.password]"
        :type="showPassword ? 'text' : 'password'"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        :disabled="isLoading"
        autocomplete="current-password"
        prepend-inner-icon="mdi-lock-outline"
        outlined
        @click:append="showPassword = !showPassword"
      ></v-text-field>

      <v-btn type="submit" block x-large depressed color="success" :loading="isLoading" :disabled="isLoading">
        {{ isLoading ? t.submitting : t.submit }}
        <v-icon right>mdi-arrow-right</v-icon>
      </v-btn>

      <v-btn block text color="success darken-2" class="mt-2" :disabled="isLoading" @click="forgotPassword">
        {{ t.forgot }}
      </v-btn>
    </v-form>

    <p class="auth-switch">
      {{ t.switch.text }}
      <router-link :to="t.switch.to" class="auth-link">{{ t.switch.link }}</router-link>
    </p>
  </auth-layout>
</template>

<script>
import authPages from '@/content/authPages';
import AuthLayout from './auth/AuthLayout.vue';

const TYPE_KEY = 'loginType';

export default {
  name: 'login',

  components: { AuthLayout },

  data() {
    const query = this.$route.query;
    let type = query.type === 'club' ? 'club' : 'user';
    if (!query.type) {
      // Zuletzt gewähltes Konto merken, Vereine melden sich meist immer als Verein an
      try {
        if (localStorage.getItem(TYPE_KEY) === 'club') type = 'club';
      } catch (e) {
        // localStorage nicht verfügbar
      }
    }
    return {
      t: authPages.login,
      types: authPages.types,
      type,
      email: query.email || '',
      password: '',
      showPassword: false
    };
  },

  computed: {
    isLoading() {
      return this.type === 'club'
        ? this.$store.getters['ClubAuth/isLoading']
        : this.$store.getters['UserAuth/isLoading'];
    }
  },

  methods: {
    login() {
      if (!this.$refs.form.validate()) return;

      try {
        localStorage.setItem(TYPE_KEY, this.type);
      } catch (e) {
        // localStorage nicht verfügbar
      }

      const data = { email: this.email.trim(), password: this.password };
      const isClub = this.type === 'club';
      const home = isClub ? '/club/home' : '/user/home';

      // Fehler zeigt die Login-Action schon als Popup an
      this.$store
        .dispatch(isClub ? 'ClubAuth/login' : 'UserAuth/login', data)
        .then(() => this.$router.push(this.redirectTarget(isClub) || home))
        .catch(err => console.log(err));
    },

    // Zurück zur Seite, von der der Router hierher umgeleitet hat – aber nur in den passenden Bereich
    redirectTarget(isClub) {
      const target = this.$route.query.redirect;
      if (typeof target !== 'string') return null;
      return target.startsWith(isClub ? '/club/' : '/user/') ? target : null;
    },

    forgotPassword() {
      const base = process.env.VUE_APP_BACKEND_URL;
      window.location.href = base + (this.type === 'club' ? 'verein/password/reset' : 'password/reset');
    }
  }
};
</script>
